import { zodResolver } from '@hookform/resolvers/zod'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import useTranslate from '../../../../lib/hooks/use-translate'
import { ContactEnum } from '../../../../lib/types/enums/enrollment/contact.enum'
import { EnrollmentInput } from '../../../../lib/types/models/enrollment/enrollment-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { PHONE_NUMBER_SCHEMA } from '../../../../lib/utils/validations/phone-number.validation'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form } from '../../../elements/forms/form'
import ValidationButtons from '../../../elements/validation-buttons'
import ContactEnrollmentForm from '../../enrollments/enrollment-form/contact-enrollment-form'

export type ContactInformationInput = Pick<
  EnrollmentInput,
  | 'personToContactInCaseOfEmergency'
  | 'personToContactInCaseOfEmergencyFullName'
  | 'personToContactInCaseOfEmergencyPhoneNumber'
  | 'parent1FirstName'
  | 'parent1LastName'
  | 'parent1PhoneNumber'
  | 'parent2FirstName'
  | 'parent2LastName'
  | 'parent2PhoneNumber'
>

export const CONTACT_INFORMATION_SCHEMA = (t: TFunction<AvailableLanguages, undefined>) =>
  z.object({
    personToContactInCaseOfEmergency: createEnumSchema({
      enumType: ContactEnum,
      fieldName: `Personne à contacter en cas d'urgence`
    }),
    personToContactInCaseOfEmergencyFullName: createStringSchema('Prénom et nom'),
    personToContactInCaseOfEmergencyPhoneNumber: PHONE_NUMBER_SCHEMA(t)
  })

const ContactInformationForm = ({
  defaultValues,
  className,
  ...validationButtonProps
}: BaseFormProps<ContactInformationInput, true>) => {
  const { t } = useTranslate()
  const form = useForm<ContactInformationInput>({
    resolver: zodResolver(CONTACT_INFORMATION_SCHEMA(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <ContactEnrollmentForm />
        </div>
        <ValidationButtons hasBorderTop {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default ContactInformationForm
